import { render, staticRenderFns } from "./products-search-results.vue?vue&type=template&id=5afa7e44&"
import script from "./products-search-results.vue?vue&type=script&lang=js&"
export * from "./products-search-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports